import { Navigate, Route, Routes, useParams } from 'react-router';
import { Layout } from './components/Layout';
import { ErrorBox, Loading } from './components/ui';
import { SessionProvider } from './lib/session';
import { Activity } from './pages/Activity';
import { Assistant } from './pages/Assistant';
import { Decisions } from './pages/Decisions';
import { Desk } from './pages/Desk';
import { Login } from './pages/Login';
import { Me } from './pages/Me';
import { Ideas } from './pages/Ideas';
import { Meetings } from './pages/Meetings';
import { MeetingRoom } from './pages/MeetingRoom';
import { ProjectRoom } from './pages/ProjectRoom';
import { Projects } from './pages/Projects';
import { Settings } from './pages/Settings';
import { Team } from './pages/Team';

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="*"
        element={
          <SessionProvider
            fallback={(s) =>
              s.kind === 'error' ? (
                <div className="center-page">
                  <ErrorBox error={`The server could not be reached: ${s.message}`} retry={() => window.location.reload()} />
                </div>
              ) : (
                <div className="center-page">
                  <Loading what="Opening your workspace" />
                </div>
              )
            }
          >
            <Routes>
              <Route element={<Layout />}>
                <Route index element={<Desk />} />
                <Route path="assistant" element={<Assistant />} />
                <Route path="assistant/:cid" element={<Assistant />} />
                <Route path="activity" element={<Activity />} />
                <Route path="ideas" element={<Ideas />} />
                <Route path="me" element={<Me />} />
                <Route path="w/:slug" element={<ToDesk />} />
                <Route path="w/:slug/desk" element={<Desk />} />
                <Route path="w/:slug/assistant" element={<Assistant />} />
                <Route path="w/:slug/assistant/:cid" element={<Assistant />} />
                <Route path="w/:slug/projects" element={<Projects />} />
                <Route path="w/:slug/projects/:pid" element={<ProjectRoom />} />
                <Route path="w/:slug/ideas" element={<Ideas />} />
                <Route path="w/:slug/meetings" element={<Meetings />} />
                <Route path="w/:slug/meetings/:mid" element={<MeetingRoom />} />
                <Route path="w/:slug/decisions" element={<Decisions />} />
                <Route path="w/:slug/team" element={<Team />} />
                <Route path="w/:slug/activity" element={<Activity />} />
                <Route path="w/:slug/settings" element={<Settings />} />
                <Route path="*" element={<NotFound />} />
              </Route>
            </Routes>
          </SessionProvider>
        }
      />
    </Routes>
  );
}

function ToDesk() {
  const { slug } = useParams();
  return <Navigate to={`/w/${slug}/desk`} replace />;
}

function NotFound() {
  return (
    <div className="state empty">
      <strong>No page here.</strong> Use the menu to go back to your desk.
    </div>
  );
}
